import UserSessionName from "./UserSessionName";
import UserSessionLink from "./UserSessionLink";

import UserName from "../../../../auth/components/user/UserDetail/UserName";
import UserLink from "../../../../auth/components/user/UserDetail/UserLink";

import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserSessionDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="UserSession-detail-title"
                    >
                        { label || t`User Session` }: <UserSessionName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="UserSession-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="UserSession-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } data-testid="userId-label" sx={{ textAlign: "left" }}><Trans>User</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="userId-value" sx={{ textAlign: "left" }}>{ data.userId ? (<UserLink id={ data.userId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="userGroupId-label" sx={{ textAlign: "left" }}><Trans>Members Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="userGroupId-value" sx={{ textAlign: "left" }}>{ data.userGroupId ? (<MembersGroupLink id={ data.userGroupId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="device-label" sx={{ textAlign: "left" }}><Trans>Device</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="device-value" sx={{ textAlign: "left" }}>{ data.device || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="createdAt-label" sx={{ textAlign: "left" }}><Trans>Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="createdAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.createdAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="updatedAt-label" sx={{ textAlign: "left" }}><Trans>Updated At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="updatedAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.updatedAt) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default UserSessionDetail;
